<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">ADMINISTRAR DESCUENTOS</h1>
        </section>

        <section id="table">
            <mat-card class="mat-elevation-z0">
                <div>
                    <button mat-flat-button class="add-btn" (click)="addDiscount()">Agregar nuevo</button>
                </div>

                <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef class="table-header">Descripción</th>
                        <td mat-cell *matCellDef="let element"> {{element.dsDescription}} </td>
                    </ng-container>

                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef class="table-header">VALOR DE DESCUENTO</th>
                        <td mat-cell *matCellDef="let element"> {{element.qtValue}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
                        <td mat-cell *matCellDef="let element" class="table-content">
                            <mat-slide-toggle [(ngModel)]="element.isEnabled"
                                (click)="enableDisable(element.cdOffer, element.isEnabled)"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="options">
                        <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-mini-fab class="edit-btn" (click)="editDiscount(element.cdOffer)"
                            matTooltip="Editar descuento"><mat-icon>create</mat-icon>
                            </button>
                            <button mat-mini-fab class="delete-btn" (click)="deleteDiscount(element.cdOffer)"
                            matTooltip="Eliminar descuento"><mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>